<template>
  <div>
    <v-radio-group
      v-model="welcome_theme.notintime.text_justify"
      hide-details=""
    >
      <template v-slot:label>
        รูปแบบการจัดวาง
      </template>
      <v-radio value="start">
        <template v-slot:label>
          <div>
            ชิดซ้าย
          </div>
        </template>
      </v-radio>
      <v-radio value="center">
        <template v-slot:label>
          <div>
            ตรงกลาง
          </div>
        </template>
      </v-radio>
      <v-radio value="end">
        <template v-slot:label>
          <div>
            ชิดขวา
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <div v-if="login_selected === 'early'">
      <v-checkbox
        v-model="welcome_theme.notintime.swap_counting"
        label="สลับข้อความนับเวลากับคำอธิบาย"
      ></v-checkbox>
      <v-card flat>
        <v-card-text class="px-0">
          ข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-text-field
            v-model="welcome_theme.notintime.counting_early_text"
            outlined
            dense
            hide-details=""
          ></v-text-field>
        </v-card-text>
        <v-card-text class="pa-0">
          สีข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-color-picker
            v-model="welcome_theme.notintime.counting_early_color"
            class="my-6"
          ></v-color-picker>
        </v-card-text>
        <v-card-text class="pa-0">
          สีข้อความนับเวลา
        </v-card-text>
        <v-card-text class="pa-0">
          <v-color-picker
            v-model="welcome_theme.notintime.counting_color"
            class="my-6"
          ></v-color-picker>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <v-checkbox
        v-model="welcome_theme.notintime.swap_end"
        label="สลับข้อความหมดเวลากับคำอธิบาย"
      ></v-checkbox>
      <v-card flat>
        <v-card-text class="px-0">
          ข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-text-field
            v-model="welcome_theme.notintime.counting_end_text"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-text class="pa-0">
          สีข้อความอธิบาย
        </v-card-text>
        <v-card-text class="pa-0">
          <v-color-picker
            v-model="welcome_theme.notintime.counting_end_color"
            class="my-6"
          ></v-color-picker>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["welcome_theme", "login_selected"],
};
</script>

<style lang="scss" scoped></style>
